var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('page-header',{attrs:{"title":_vm.title,"items":_vm.items}}),_c('awesome-table',{attrs:{"labels":_vm.labels,"items":_vm.filtered,"options":_vm.options,"pagination":_vm.pagination},on:{"row-click":_vm.goToEdit,"search":_vm.onSearch,"pagination-change":_vm.onPaginationChange}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }